import { render, staticRenderFns } from "./sheet.vue?vue&type=template&id=212d534f&scoped=true&"
import script from "./sheet.vue?vue&type=script&lang=js&"
export * from "./sheet.vue?vue&type=script&lang=js&"
import style0 from "./sheet.vue?vue&type=style&index=0&id=212d534f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212d534f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212d534f')) {
      api.createRecord('212d534f', component.options)
    } else {
      api.reload('212d534f', component.options)
    }
    module.hot.accept("./sheet.vue?vue&type=template&id=212d534f&scoped=true&", function () {
      api.rerender('212d534f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sheet/sheet.vue"
export default component.exports